module.exports = __webpack_public_path__ + "img/album23_11.f37c0100.jpg";